const state = {
    routeList: [
        {
            "name": "Index",
            "path": "/index",
            "hidden": false,
            "component": "Layout",
            "meta": {
                "title": "首页",
                "icon": "#",
                "noCache": false
            }
        },
        {
            "name": "MetroStation",
            "path": "/metroStation",
            "hidden": false,
            "component": "Layout",
            "alwaysShow": true,
            "meta": {
                "title": "地铁站台",
                "icon": "#",
                "noCache": false
            },
        },
        {
            "name": "Demo",
            "path": "/demo",
            "hidden": false,
            "component": "Layout",
            "alwaysShow": true,
            "meta": {
                "title": "Demo",
                "icon": "druid",
                "noCache": false
            },
            "children": [
                {
                    "name": "FormDemo",
                    "path": "formDemo",
                    "hidden": false,
                    "component": "formDemo/index",
                    "meta": {
                        "title": "表单控件",
                        "icon": "druid",
                        "noCache": false
                    }
                },
                // {
                //     "name": "DrawShapes",
                //     "path": "drawShapes",
                //     "hidden": false,
                //     "component": "drawShapes/index",
                //     "meta": {
                //         "title": "canvas画图",
                //         "icon": "druid",
                //         "noCache": false
                //     }
                // },
                {
                    "name": "VirtualDemo",
                    "path": "virtualDemo",
                    "hidden": false,
                    "component": "virtualDemo/index",
                    "meta": {
                        "title": "虚拟滚动",
                        "icon": "druid",
                        "noCache": false
                    }
                },
                {
                    "name": "LargeFileDemo",
                    "path": "largeFileDemo",
                    "hidden": false,
                    "component": "largeFileDemo/index",
                    "meta": {
                        "title": "大文件上传",
                        "icon": "cascader",
                        "noCache": false
                    }
                },
                {
                    "name": "VideoPlay",
                    "path": "videoPlay",
                    "hidden": false,
                    "component": "videoPlay/index",
                    "meta": {
                        "title": "实时视频",
                        "icon": "cascader",
                        "noCache": false
                    }
                },
            ]
        },
        {
            "name": "System",
            "path": "/system",
            "hidden": false,
            "redirect": "noRedirect",
            "component": "Layout",
            "alwaysShow": true,
            "meta": {
                "title": "系统管理",
                "icon": "system",
                "noCache": false
            },
            "children": [
                {
                    "name": "User",
                    "path": "user",
                    "hidden": false,
                    "component": "system/user/index",
                    "meta": {
                        "title": "用户管理",
                        "icon": "user",
                        "noCache": false
                    }
                },
                {
                    "name": "Role",
                    "path": "role",
                    "hidden": false,
                    "component": "system/role/index",
                    "meta": {
                        "title": "角色管理",
                        "icon": "peoples",
                        "noCache": false
                    }
                },
                {
                    "name": "Menu",
                    "path": "menu",
                    "hidden": false,
                    "component": "system/menu/index",
                    "meta": {
                        "title": "菜单管理",
                        "icon": "tree-table",
                        "noCache": false
                    }
                },
                {
                    "name": "Dept",
                    "path": "dept",
                    "hidden": false,
                    "component": "system/dept/index",
                    "meta": {
                        "title": "班组管理",
                        "icon": "user",
                        "noCache": false
                    }
                },
                {
                    "name": "Log",
                    "path": "log",
                    "hidden": false,
                    "redirect": "noRedirect",
                    "component": "ParentView",
                    "alwaysShow": true,
                    "meta": {
                        "title": "日志管理",
                        "icon": "log",
                        "noCache": false
                    },
                    "children": [
                        {
                            "name": "Operlog",
                            "path": "operlog",
                            "hidden": false,
                            "component": "monitor/operlog/index",
                            "meta": {
                                "title": "操作日志",
                                "icon": "form",
                                "noCache": false
                            }
                        },
                        {
                            "name": "Logininfor",
                            "path": "logininfor",
                            "hidden": false,
                            "component": "monitor/logininfor/index",
                            "meta": {
                                "title": "登录日志",
                                "icon": "logininfor",
                                "noCache": false
                            }
                        }
                    ]
                }
            ]
        },
        {
            "name": "Base",
            "path": "/base",
            "hidden": false,
            "component": "Layout",
            "alwaysShow": true,
            "meta": {
                "title": "基础管理",
                "icon": "dict",
                "noCache": false
            },
            "children": [
                {
                    "name": "CityManage",
                    "path": "cityManage",
                    "hidden": false,
                    "component": "base/cityManage/index",
                    "meta": {
                        "title": "城市管理",
                        "icon": "textarea",
                        "noCache": false
                    }
                },
                {
                    "name": "LineManage",
                    "path": "lineManage",
                    "hidden": false,
                    "component": "base/lineManage/index",
                    "meta": {
                        "title": "线路管理",
                        "icon": "online",
                        "noCache": false
                    }
                },
                {
                    "name": "MetroManage",
                    "path": "metroManage",
                    "hidden": false,
                    "component": "base/metroManage/index",
                    "meta": {
                        "title": "车辆管理",
                        "icon": "shopping",
                        "noCache": false
                    }
                },
                {
                    "name": "DriverInfo",
                    "path": "driverInfo",
                    "hidden": false,
                    "component": "driverInfo/index",
                    "meta": {
                        "title": "司机管理",
                        "icon": "email",
                        "noCache": false
                    }
                },

            ]
        },
    ],
}
export default {
    namespaced: true,
    state,
}